// extracted by mini-css-extract-plugin
export default {"cls1":"I82s3bZ78gs7nTaLied0","cls2":"reWQ2wYZWmOy8wkuhtB9 I82s3bZ78gs7nTaLied0"};